import React from 'react';
import useDemographJobProgress from '../../hooks/useDemographJobProgress';
import useDemographStatusPolling from '../../hooks/useDemographStatusPolling';
import { useAudienceBuilderContext } from '../../../platform/ux/Demographics/context/AudienceBuilderContext';

const DemographicsMainController = (props) => {
  const {
    history,
    audienceSchema,
    audienceDemographs,
    saveAudiencesToApi,
    activateDemographAudiences,
    publishDemographAudience,
    createAudienceDemograph,
    updateAudienceDemograph,
    refetchAudienceDemographs,
    deleteAudienceDemograph,
    refetchAudienceCount,
    refetchAudienceSchema,
    loadingPublishing,
    loadingPublish,
    loadingAudienceCount,
    loadingAudienceSchema,
    loadingAudienceDemographs,
    orgId,
    userId,
    getAudienceDemographs,
  } = props;

  const { updateJobStatus, clearJobStatus } = useAudienceBuilderContext();

  const handleFetchAudienceDemographs = async (props = {}) => {
    const { nameSearch = undefined, isArchived = false, isPublished = undefined } = props;
    getAudienceDemographs({
      variables: {
        whereParameters: {
          org: { id: orgId },
          name_contains: nameSearch,
          isArchived: isArchived,
          isPublished: isPublished,
        },
      },
    });
  };

  useDemographJobProgress(orgId, {
    updateJobStatus,
    clearJobStatus,
    onJobCompleted: () => handleFetchAudienceDemographs(),
  });

  // Polling fallback: reconcile status from internal-service when subscription isn't delivering
  useDemographStatusPolling(audienceDemographs, {
    onStatusChanged: () => handleFetchAudienceDemographs(),
  });

  const handleSaveAudiencesToApi = async (data) => {
    return saveAudiencesToApi({ variables: { data: { ...data, orgId } } });
  };

  const handleCreateAudience = async (data) => {
    return createAudienceDemograph({
      variables: {
        data: {
          name: data.name,
          description: data.description,
          reachCount: data.reachCount,
          tags: { set: data.tags },
          metrics: { set: data.metrics },
          createdBy: { connect: { id: userId } },
          org: { connect: { id: orgId } },
        },
      },
    });
  };

  const handleActivateAudience = async (audience) => {
    return activateDemographAudiences({
      variables: {
        data: { ...audience, orgId },
      },
    });
  };

  const handlePublishAudience = async (audience) => {
    return publishDemographAudience({
      variables: {
        data: { ...audience, orgId },
      },
    });
  };

  const handleUpdateAudience = async (data) => {
    const { id = null } = data;

    if (!id) {
      return false;
    }

    delete data.id;

    return updateAudienceDemograph({
      variables: {
        id: id,
        data: { ...data },
      },
    });
  };

  const deleteAudience = async (id) => {
    return deleteAudienceDemograph({
      variables: {
        id: id,
      },
    });
  };

  const fetchAudienceCount = async (params) => {
    return await refetchAudienceCount({
      metric: params,
    });
  };

  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        history,
        audienceSchema,
        audienceDemographs,
        refetchAudienceDemographs,
        refetchAudienceSchema,
        loadingPublishing,
        loadingPublish,
        loadingAudienceCount,
        loadingAudienceSchema,
        loadingAudienceDemographs,
        handleSaveAudiencesToApi,
        handleCreateAudience,
        handleUpdateAudience,
        handleActivateAudience,
        handlePublishAudience,
        deleteAudience,
        fetchAudienceCount,
        handleFetchAudienceDemographs,
      })}
    </React.Fragment>
  );
};

export default DemographicsMainController;
